import orderUtil from "../Utils/orderUtil.js";
const Css = {
  qrCodeDiv(w,h,pf){
    let bgcolor =  "#252525"
    if (pf === 'Audiodesires_demo') {
      bgcolor = "#c24866"
    }
    return {
      width: w + "px",
      height: h + "px",
      position: "relative",
      backgroundColor:bgcolor,
      // position: "absolute",
      // zIndex:4,
    }
  },
  qrCodeDiv2(w,h){
    return {
      height: h + "px",
      marginTop: (0-h) + "px",
    }
  },
  codeArea1(w, pf){
    let fs = "16px";
    let fs2 = "15px";
    let tlmrg = "16px 0 4px 0";
    let tit1 = "#EAEAEA";
    let tit2 = "#ccc";
    let here = "#FF2D89"
    if(pf === "t9" || pf === "t10"){
      fs = "15px";
      fs2 = "14px";
      tlmrg = "14px 0 2px 0";
    }
    if (pf === 'Audiodesires_demo') {
      tit1 = "#000"
      tit2 = "#000"
      here = "#b75d59"
    }
    let txtAreaMl = 50;
    let txtW = "870px";
    if(w < 960){
      txtAreaMl = 30;
      fs = "14px";
      txtW = "490px";
    }
    let res = {
      width: "100%",
      overflow:"hidden",
      txtArea:{
        width: txtW,
        height: "264px",
        float: "left",
        margin: "0 0 0 " + txtAreaMl + "px",
        padding: "10px 0"
      },
      title:{
        color: tit1,
        fontSize: fs,
        margin: tlmrg,
      },
      title2:{
        color: tit2,
        fontSize: fs2,
      },
      dno:{
        color: tit1,
        fontSize: fs,
        marginTop: "20px",
      },
      here: {
        color: here,
        cursor: "pointer",
      },
      rightArea:{
        width: "140px",
        height: "180px",
        position:'absolute',
        right: "50px",
        top: "60px"
      },
      codeImg:{
        width: "140px",
        height: "140px",
        backgroundColor: "#555",
      },
      codeTxt: {
        width: "140px",
        height: "20px",
        lineHeight: "20px",
        textAlign: "center",
        fontSize: "16px",
        color: "#EAEAEA",
        margin: "20px 0 0",
        float: "right"
      },
      closeBtn:{
        width: "50px",
        height: "50px",
        float: "right",
        position: "absolute",
        right: "14px"
      },
      closeImg: {
        margin: "14px 0 0 20px",
        cursor: "pointer"
      }
    };
    return res;
  },
  div2Layer(w,h){
    return {
      width: w + "px",
      height: h + "px",
      position: "absolute",
      zIndex: 3,
      backgroundColor: "#000",
      filter:"alpha(Opacity=80)",
      MozOpacity: 0.5,
      opacity: 0.5
    }
  },
  codeArea2(width, pf){
    if(width <= 640){
      width = 640
    }
    let redTitleObj = {
      color: "#ff2d89",
      fontSize: "18px",
      height: "28px",
      lineHeight: "28px",
      margin: "16px 0 8px 0",
      overflow:"hidden"
    }
    let titleObj = {
      color: "#EAEAEA",
      fontSize: "16px",
      margin: "14px 0 6px 0"
    }
    if(width - 200 - 280 < 530){
      redTitleObj.fontSize = "16px";
      titleObj.fontSize = "14px";
    }
    let codeMargin = 160;
    let txtAreaMl = 50;
    let txtAreaW = (width - codeMargin - 280) + "px";
    if(width < 960){
      codeMargin = 80;
      txtAreaMl = 30;
      redTitleObj.margin = "14px 0 0 0";
      titleObj.margin = "10px 0 0 0";
      txtAreaW = (width - 60 - 280) + "px";
    }
    
    let caHeight = orderUtil.canvasHeight + "px";
    let camrt = "42px";
    let ramrt = "30px";
    if(pf === "t9" || pf === "t10"){
      caHeight = "230px";
      camrt = "28px";
      ramrt = "45px";
    }

    let res = {
      width: (width - codeMargin) + "px",
      height: caHeight,
      margin: camrt + " " + codeMargin/2 + "px",
      backgroundColor: "#252525",
      position: "absolute",
      zIndex: 4,
      txtArea:{
        width: txtAreaW,
        height: caHeight,
        float: "left",
        margin: "0 0 0 " + txtAreaMl + "px",
      },
      redTitle:redTitleObj,
      title:titleObj,
      span:{
        color: "#ccc",
        fontSize: "14px",
        marginLeft: "14px"
      },
      dno:{
        color: "#EAEAEA",
        fontSize: "16px",
        marginTop: "20px",
      },
      here: {
        color: "#FF2D89",
        cursor: "pointer",
      },
      rightArea:{
        width: "140px",
        height: "180px",
        float: "right",
        margin: ramrt + " 60px 0 0"
      },
      codeImg:{
        width: "140px",
        height: "140px",
        backgroundColor: "#555",
      },
      closeBtn:{
        width: "50px",
        height: "50px",
        float: "right",
        position: "absolute",
        right: "14px"
      },
      closeImg: {
        margin: "14px 0 0 20px",
        cursor: "pointer"
      }
    }
    if(width<960){
      res.margin = "42px 40px";
    }
    return res;
  },
}

export default Css;